function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Capa_x0020_1"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  width: 228.56,
  height: 228.56
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M103.64 39.55c-85.54,17.24 -32.68,146.79 19.65,128.55 21.63,-7.53 46.84,-43.06 45.29,-75.49 -1.53,-32.12 -30.38,-60.03 -64.94,-53.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M103.16 47.46c-73.52,17.15 -22.4,129.77 20.01,112.29 16.42,-6.78 38.73,-39.27 37.31,-67.14 -1.41,-27.89 -27.21,-52.18 -57.32,-45.15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M52.68 137.29c-1.82,-7.79 0.05,-15.18 -6.8,-40.56 -15.34,-56.85 81.19,-107.62 125.18,-41.88 25.66,38.35 -2.03,45.55 3.19,75.81 27.96,7.91 29.97,-26.75 22.01,-36.02 -14.27,-16.62 -1.51,-1.03 -10.47,-26.19 -8.65,-24.29 -31.14,-46.35 -58.86,-50.76 -23.31,-3.72 -43.97,2.96 -59.29,13.49 -28.83,19.81 -29.66,52.96 -32.98,58.12 -3.49,5.43 -6.19,2.35 -8.62,10.14 -2.34,7.54 1.55,24.76 6.5,28.98 12.18,10.41 9.87,-3.25 16.49,20.48 9.7,34.75 44.74,26.04 13.47,-3.74 -4.32,-4.11 -5.45,-3.18 -9.82,-7.87z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M26.11 212.3c19.82,2.26 8.5,-11.39 38.61,-21.74 22.37,-7.69 23.08,9.83 48.21,9.86 24.98,0.02 24.66,-17.67 46.04,-9.74 8.15,3.02 14.01,6.15 19.77,10.71 8.63,6.82 7.61,12.55 20.89,10.86 -6.06,-11.56 -20.74,-22.88 -36.06,-28.16 -34.62,-11.93 -19.4,8.54 -50.66,8.43 -28.25,-0.1 -21.84,-18.7 -49.87,-9.7 -15.62,5.01 -32.38,17.57 -36.93,29.48z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M180.81 125.65c11.05,-1.56 9.32,-1.7 11.25,-12.69 1.72,-9.79 3.88,-10.96 -4.05,-14.93 -4.16,6.04 -6.01,18.89 -7.2,27.62z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M44.47 125.01c-1.18,-9.05 -2.76,-20.02 -6.64,-27 -7.78,3.63 -6.38,5.24 -4.28,14.99 2,9.34 1.45,10.76 10.92,12.01z"
}));

var SvgAtencion = function SvgAtencion(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlSpace: "preserve",
    width: "2em",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 228.56 228.56",
    role: "img",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAtencion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Atencion.4a549d8a.svg";
export { ForwardRef as ReactComponent };